/**
 * Fluent v9 light/dark themes generated from the Consono brand ramp.
 *
 * The brand ramp is anchored so that the default brand fill (`brand[80]`, used
 * for primary buttons etc.) sits near `greenDark` — dark enough for white text
 * to pass WCAG AA — while the bright accent green (#A8D600) lives high in the
 * ramp for highlights, never body text (UI_COMPONENTS.md §1).
 */
import {
  createLightTheme,
  createDarkTheme,
  type BrandVariants,
  type Theme,
} from '@fluentui/react-components';
import { typography } from './tokens';

const consonoGreen: BrandVariants = {
  10: '#050600',
  20: '#141b02',
  30: '#1f2b00',
  40: '#293900',
  50: '#334700',
  60: '#3d5a00', // greenDark — emphasis fills / table headers
  70: '#4a6d00',
  80: '#588000', // default brand fill (white text passes AA)
  90: '#679400',
  100: '#77a800',
  110: '#88bd00',
  120: '#99cc00',
  130: '#a8d600', // bright accent — highlights only
  140: '#bbe23f',
  150: '#d2ec7f',
  160: '#e9f6c2',
};

function withBrandFonts(base: Theme): Theme {
  return {
    ...base,
    fontFamilyBase: typography.fontFamilyBase,
    fontFamilyMonospace: typography.fontFamilyMono,
    fontFamilyNumeric: typography.fontFamilyBase,
  };
}

export const lightTheme: Theme = withBrandFonts(createLightTheme(consonoGreen));
export const darkTheme: Theme = withBrandFonts(createDarkTheme(consonoGreen));

export type ThemeName = 'light' | 'dark';

export const themes: Record<ThemeName, Theme> = {
  light: lightTheme,
  dark: darkTheme,
};
